'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IconGenderFemale = function IconGenderFemale(_ref) {
  var color = _ref.color,
      custom = _objectWithoutProperties(_ref, ['color']);

  return _react2.default.createElement(
    'svg',
    _extends({ fill: 'none', height: '24', viewBox: '0 0 24 24', width: '24' }, custom),
    _react2.default.createElement(
      'g',
      { fill: color },
      _react2.default.createElement('path', { d: 'M11.9958145,2.98384463 C10.2211619,2.98384463 8.54696133,3.67026687 7.2913109,4.9342883 C6.02728947,6.18993872 5.34086724,7.86413929 5.34086724,9.63879189 C5.34086724,11.4218155 6.03566047,13.0960161 7.2913109,14.3516665 C8.54696133,15.6073169 10.2211619,16.3021102 11.9958145,16.3021102 C13.7788381,16.3021102 15.4530387,15.6073169 16.7086891,14.3516665 C17.9643395,13.0960161 18.6591328,11.4218155 18.6591328,9.63879189 C18.6591328,7.86413929 17.9643395,6.18993872 16.7086891,4.9342883 C15.4530387,3.67026687 13.7788381,2.98384463 11.9958145,2.98384463 Z M11.9958145,17.9763107 C9.76912774,17.9763107 7.67637703,17.1057264 6.10262849,15.5319779 C4.52887996,13.9582294 3.66666667,11.8654787 3.66666667,9.63879189 C3.66666667,7.41210514 4.52887996,5.31935443 6.10262849,3.74560589 C7.67637703,2.17185736 9.76912774,1.30964406 11.9958145,1.30964406 C14.2225013,1.30964406 16.315252,2.17185736 17.8890005,3.74560589 C19.462749,5.31935443 20.3333333,7.41210514 20.3333333,9.63879189 C20.3333333,11.8654787 19.462749,13.9582294 17.8890005,15.5319779 C16.315252,17.1057264 14.2225013,17.9763107 11.9958145,17.9763107 L11.9958145,17.9763107 Z', transform: 'translate(12.000000, 9.642977) rotate(-45.000000) translate(-12.000000, -9.642977) ' }),
      ' ',
      _react2.default.createElement('path', { d: 'M9.96585895,21.9677022 C9.64781614,21.6416405 9.64781614,21.1280933 9.96585895,20.8101831 L12.884294,17.8938499 C13.2023368,17.5759397 13.7160982,17.5759397 14.0341411,17.8938499 C14.3521839,18.2117601 14.3521839,18.7334588 14.0341411,19.051369 L11.115706,21.9677022 C10.9607621,22.1225816 10.7487336,22.204097 10.54486,22.204097 C10.3328314,22.204097 10.1289578,22.1225816 9.96585895,21.9677022 Z', transform: 'translate(12.000000, 19.929757) rotate(-45.000000) translate(-12.000000, -19.929757) ' }),
      ' ',
      _react2.default.createElement('path', { d: 'M13.5554459,22.4575485 L9.22279738,18.1295194 C8.90475456,17.8117681 8.90475456,17.29033 9.22279738,16.9725787 C9.54084019,16.6548274 10.0546017,16.6548274 10.3726445,16.9725787 L14.705293,21.3006079 C15.0233359,21.6183592 15.0233359,22.1316498 14.705293,22.4575485 C14.5503491,22.6123505 14.3383206,22.6938252 14.134447,22.6938252 C13.9224184,22.6938252 13.7185448,22.6123505 13.5554459,22.4575485 Z', transform: 'translate(11.964045, 19.714045) rotate(-45.000000) translate(-11.964045, -19.714045) ' }),
      ' '
    )
  );
};

IconGenderFemale.propTypes = {
  color: _propTypes2.default.string
};

IconGenderFemale.defaultProps = {
  color: _colors2.default.icons
};

IconGenderFemale.displayName = 'IconGenderFemale';

exports.default = IconGenderFemale;
module.exports = exports.default;